import { useField, useFormikContext } from 'formik'
import { VoiceAndTonesSelect } from 'components/VoiceAndTonesSelect/VoiceAndTonesSelect'
import { useBrandVoices } from 'hooks/useBrandVoices'
import { useCurrentWorkspace } from 'hooks/useCurrentWorkspace'
import { Tone } from 'components/VoiceAndTonesSelect/Types'
import { FormikVoiceInputProps, FormStatus, VoiceInputProps } from 'components/Wizards/Wizard/Form/Types'
import { FormButton } from '../FormButton/FormButton'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import Styles from './Field.module.scss'
import { TextFieldLoadingState } from 'components/Wizards/TextFieldLoadingState/TextFieldLoadingState'

export const VoiceInput = ({ onVoiceChange, onTonesChange, voiceId, tones, popoverClassName }: VoiceInputProps) => {
  const currentWorkspace = useCurrentWorkspace()
  const { data: voices } = useBrandVoices(currentWorkspace)
  const { isMobile } = useResponsiveDesign()

  return (
    <VoiceAndTonesSelect
      voices={[...(voices ?? [])].reverse()}
      tones={Object.values(Tone)}
      selectedTones={tones}
      selectedVoiceIds={[voiceId].filter(Boolean) as number[]}
      onToneSelect={async (tone) => {
        await onVoiceChange(undefined)
        const tonesSet = new Set(tones)
        tonesSet.has(tone) ? tonesSet.delete(tone) : tonesSet.add(tone)
        return onTonesChange(Array.from(tonesSet).slice(0, 3))
      }}
      onVoiceSelect={async (id) => {
        await onTonesChange([])
        if (voiceId === id) {
          return onVoiceChange(undefined)
        }
        return onVoiceChange(id)
      }}
      disabledTones={tones.length >= 3 ? Object.values(Tone).filter((tone) => !tones.includes(tone)) : []}
      ButtonComponent={isMobile ? FormButton : undefined}
      popoverClassName={popoverClassName}
    />
  )
}

export const FormikVoiceInput = ({
  voiceFieldName = 'brand_voice_id',
  tonesFieldName = 'tone',
}: FormikVoiceInputProps) => {
  const { status } = useFormikContext()
  const [brandVoiceIdField, ,] = useField(voiceFieldName)
  const [toneField, , { setValue: setTone }] = useField(tonesFieldName)
  const { setValues } = useFormikContext<{ [key: string]: any }>()

  const setBrandVoiceId = (voiceId: number | undefined) => {
    setValues((values) => ({
      ...values,
      brand_voice_id: voiceId,
    }))
  }

  if (status === FormStatus.AutoFilling) {
    return <TextFieldLoadingState fixedWidth={250} />
  }

  return (
    <VoiceInput
      onVoiceChange={setBrandVoiceId}
      onTonesChange={setTone}
      tones={toneField.value}
      voiceId={brandVoiceIdField.value}
      popoverClassName={Styles.popoverClassName}
    />
  )
}
